package app.nestbridge.feature.profile.ui

import app.nestbridge.feature.profile.screen.CreateProfessionalProfileScreen
import app.nestbridge.feature.profile.screen.CreateProfessionalProfileState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class CreateProfessionalProfileUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is CreateProfessionalProfileScreen -> ui<CreateProfessionalProfileState> { state, modifier -> CreateProfessionalProfileUi(state = state, modifier = modifier) }
    else -> null
  }
}
